import { ReduxCachedState } from 'common/utils/reduxCache'
import { ContentType } from 'common/constants/index'
import { Content, ContentWithProducts } from './mongo/content'
import { ContentEditorType } from 'common/constants/product/contentEditorType'

export interface NewsState extends ReduxCachedState {
  articles: ContentWithProducts[]
  hasMore?: boolean
  keyContent?: Content
  pageCount?: number
  page?: number
  contentType?: ContentType
  includedTypes?: ContentType[]
  storeId?: string
  inquiryPageSize?: number
  restoredByHistory?: boolean
}

export interface ProductNotice {
  channelNotice?: ArticleDetailState
  productNotice?: ArticleDetailState
}

export interface ProductNoticeContent {
  channelNoticeContent?: EditorContent
  productNoticeContent?: EditorContent
}

export interface ArticleDetailState extends ReduxCachedState {
  contentsBBSVO: ContentSummary
  editorDetailContentVO: EditorContent
  content?: Content
  otherNews?: Content[]
}

export interface ContentSummary {
  id: string
  bbsCategoryType: string
  contentsFreeTrial?: ContentsFreeTrial
  bbsTitle: string
  readCount: number
  regDate: string
  contentsDisplayStatusType: ContentsDisplayStatus
  displayLocationType?: ContentDisplayLocation
  storePopupDisplayStartDate?: Date
  storePopupDisplayEndDate?: Date
}

export enum ContentsDisplayStatus {
  WAIT = 'WAIT',
  ON = 'ON',
  SUSPENSION = 'SUSPENSION',
}

export enum ContentDisplayLocation {
  ALL = 'ALL',
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}

export interface ContentsFreeTrial {
  bestPostscriptAnnouncementDate?: string
  bestPostscriptRewardContent?: string
  bestPostscriptRewardPersonnel?: number
  bestPostscriptWriterList?: FreeTrialWriter[]
  currentRecruitPersonnelCount?: number
  freeTrialProducts?: FreeTrialProduct[]
  postscriptEndDate?: string
  postscriptStartDate?: string
  postscriptYn?: boolean
  prizeWinners?: { [key: number]: FreeTrialWriter[] }
  prizeWinningAnnouncementDate?: string
  recruitEndDate?: string
  recruitStartDate?: string
  totalRecruitPersonnelCount?: number
  totalCommentCount: number
}

export interface FreeTrialWriter {
  maskedPrizeWinnerName?: string
  userDefineOptionSeq?: number
  writerMaskingId?: string
}

export interface FreeTrialProduct {
  id?: string
  productNo?: number
  productName?: string
  recruitPersonnelCount?: number
  userDefineOptions?: FreeTrialProductUserDefineOption[]
}

export interface FreeTrialProductUserDefineOption {
  count?: number
  name?: string
  seq?: number
}

export interface EditorContent extends ReduxCachedState {
  contentId: string
  editorType: ContentEditorType
  textContent: string
  renderContent: string
  mobileRenderContent: string
  storeId?: string
}
